import React, { useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import "./Sidebar.css";
import {
  FaHome,
  FaUserShield,
  FaUsersCog,
  FaUsers,
  FaUtensils,
  FaClipboardList,
  FaExchangeAlt,
  FaQuestionCircle,
  FaInfoCircle,
  FaBook,
  FaUserSlash,
  FaBell,
  FaSignOutAlt,
  FaChevronUp,
} from "react-icons/fa";
import {
  about_icon,
  admin_icon,
  blocked_icon,
  CirclesFour,
  dashboar_icon,
  faq_icon,
  food_icon,
  Grown,
  help_icon,
  logo,
  menu,
  notification_icon,
  order_icon,
  role_icon,
  transaction_icon,
  user_icon,
  videoIcon,
} from "../../assets/img/imgIndex";
import LogoutModal from "../LogoutModal/LogoutModal";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import Loader from "../Loader";
import usePermission from "../../customHook/usePermission";
import { FaChevronDown } from "react-icons/fa";

const Sidebar = ({ isViewed, setIsViewed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  let permission = usePermission();
  const [openMenu, setOpenMenu] = useState("");

  console.log("permission", permission);

  const handleLogoutConfirm = () => {
    post(URLS.LOGOUT)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);

          // updatePermission(res?.admin?.permissions);
          localStorage.clear();
          setShowLogoutModal(false);
          // navigate("/");
          setLoading(false);

          // localStorage.setItem("token", "123456789");
          // localStorage.setItem("userId", JSON.stringify(formData));
          // navigate("/dashboard");
          setTimeout(() => {
            navigate("/");
          }, 1500);
        } else {
          setLoading(false); // in case status isn't success
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
        // toast.error(err?.message);
      });
  };

  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  const menuItems = [
    {
      path: "/dashboard",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={dashboar_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Dashboard",
    },
    {
      path: "/admin",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={admin_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Admin",
      activeRoutes: ["/admin", "/add-admin"],
    },
    {
      path: "/roles",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={role_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Roles",
      activeRoutes: ["/roles", "/add-roles"],
    },
    {
      path: "/users",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={user_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Users",
      activeRoutes: ["/users", "/users-view"],
    },
    {
      path: "/foods",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={food_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Foods Management",
      activeRoutes: ["/foods", "/foods-view"],
    },
    {
      path: "/orders",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={order_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Order's Management",
      activeRoutes: ["/orders", "/orders-view"],
    },
    {
      path: "/subscription",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={Grown}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Subscription",
      activeRoutes: ["/subscription", "/subscription-view"],
    },
    // {
    //   path: "/transactions",
    //   icon: (
    //     <div style={{ width: 24, height: 24 }}>
    //       <img
    //         src={transaction_icon}
    //         alt=""
    //         style={{ width: "100%", height: "100%" }}
    //       />
    //     </div>
    //   ),
    //   label: "Transactions",
    // },
    {
      path: "/master",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={CirclesFour}
            alt=""
            style={{ width: "100%", height: "100%", marginTop: -4 }}
          />
        </div>
      ),

      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <span>Master</span>

          {openMenu === "/master" ? (
            <FaChevronUp />
          ) : (
            <FaChevronDown />
          )}
        </div>
      ),

      type: "submenu",

      children: [
        {
          path: "/master/kilometer-radius",
          label: "Kilometer Radius",
        },
        {
          path: "/master/food-availability-duration",
          label: "Food Availability Duration",
        },
      ],
    },
    {
      path: "/video",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={videoIcon}
            alt=""
            style={{ width: "100%", height: "100%", marginTop: -4 }}
          />
        </div>
      ),
      label: "Videos",
    },
    {
      path: "/help",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={help_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Help & Support",
      activeRoutes: ["/help", "/help-edit"],
    },
    {
      path: "/about",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={about_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "About Us",
      activeRoutes: ["/about", "/about-edit"],
    },
    {
      path: "/faq",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={faq_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "FAQ",
      activeRoutes: ["/faq", "/faq-edit"],
    },
    {
      path: "/blocked",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={blocked_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Blocked Seller",
      activeRoutes: ["/blocked", "/blocked-view"],
    },
    {
      path: "/notifications",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={notification_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "Push Notifications",
      activeRoutes: ["/notifications", "/notification-add"],
    },
    {
      path: "/inappUpdate",
      icon: (
        <div style={{ width: 24, height: 24 }}>
          <img
            src={notification_icon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ),
      label: "In-App Update",
      activeRoutes: ["/inappUpdate", "/notification-add"],
    },
  ];

  const isMenuItemActive = (item) => {
    if (item.activeRoutes) {
      return item.activeRoutes.includes(location.pathname);
    }
    if (item.children) {
      return item.children.some((child) => location.pathname === child.path);
    }
    return location.pathname === item.path;
  };

  const [openSubMenu, setOpenSubMenu] = useState(false);

  const handleMasterClick = (e) => {
    e.preventDefault();
    setOpenMenu(openMenu === "/master" ? "" : "/master");
    setOpenSubMenu((prev) => !prev);
  };

  return (
    <div className={`sidebar ${isViewed ? "collapsed" : ""}`}>
      <div className="sidebar-logo">
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            overflow: "hidden",
          }}
        >
          <img src={logo} alt="" style={{ width: "100%", height: "100%" }} />
        </div>
        <div
          style={{ width: 32, height: 32, cursor: "pointer" }}
          onClick={() => setIsViewed(!isViewed)}
        >
          <img src={menu} alt="" style={{ width: "100%", height: "100%" }} />
        </div>
      </div>

      <nav className="sidebar-menu">
        {menuItems.map((item, index) => {
          switch (item.label) {
            case "Admin":
              if (!permission.includes("CAN-LIST-ADMIN_LIST")) {
                return null;
              }
              break;
            case "Roles":
              if (!permission.includes("CAN-LIST-ADMIN_ROLES")) {
                return null;
              }
              break;
            case "Users":
              if (!permission.includes("CAN-LIST-USERS")) {
                return null;
              }
              break;
            case "Foods Management":
              if (!permission.includes("CAN-LIST-FOODS_MANAGEMENT")) {
                return null;
              }
              break;
            case "Order's Management":
              if (!permission.includes("CAN-LIST-ORDERS_MANAGEMENT")) {
                return null;
              }
              break;
            case "Transactions":
              if (!permission.includes("CAN-LIST-TRANSACTION")) {
                return null;
              }
              break;
            case "Help & Support":
              if (!permission.includes("CAN-LIST-HELP_AND_SUPPORT")) {
                return null;
              }
              break;
            case "About Us":
              if (!permission.includes("CAN-LIST-ABOUT_US")) {
                return null;
              }
              break;
            case "FAQ":
              if (!permission.includes("CAN-LIST-FAQ")) {
                return null;
              }
              break;
            case "Blocked Seller":
              if (!permission.includes("CAN-LIST-BLOCKED_SELLER")) {
                return null;
              }
              break;

            case "Push Notifications":
              if (!permission.includes("CAN-LIST-PUSH_NOTIFICATION")) {
                return null;
              }
              break;
            case "Master":
              if (!permission.includes("CAN-LIST-MASTER")) {
                return null;
              }
              break;

            case "Videos":
              if (!permission.includes("CAN-LIST-VIDEOS")) {
                return null;
              }
              break;

            default:
              break;
          }
          if (item.type === "submenu") {
            return (
              <div key={index}>
                <a
                  href={item.path}
                  onClick={handleMasterClick}
                  className={
                    isMenuItemActive(item)
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  <span className="menu-icon">{item.icon}</span>
                  {!isViewed && (
                    <span className="menu-label">{item.label}</span>
                  )}
                </a>

                {!isViewed && openSubMenu && (
                  <div className="submenu-list">
                    {item.children?.map((child) => (
                      <NavLink
                        key={child.path}
                        to={child.path}
                        className={
                          location.pathname === child.path
                            ? "submenu-item active"
                            : "submenu-item"
                        }
                      >
                        {child.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            );
          }

          return (
            <NavLink
              key={index}
              to={item.path}
              className={
                isMenuItemActive(item) ? "menu-item active" : "menu-item"
              }
            >
              <span className="menu-icon">{item.icon}</span>
              {!isViewed && <span className="menu-label">{item.label}</span>}
            </NavLink>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogoutClick}>
          <FaSignOutAlt />
          {!isViewed && <span>Log Out</span>}
        </button>
      </div>

      <LogoutModal
        isOpen={showLogoutModal}
        onClose={handleLogoutCancel}
        onConfirm={handleLogoutConfirm}
      />
      {loading && <Loader />}
    </div>
  );
};

export default Sidebar;
